import * as React from 'react'

function SvgIllustration500(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      viewBox="0 0 330 250"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      ref={svgRef}
      {...props}
    >
      <defs>
        <linearGradient x1="18.04%" y1="87.79%" x2="18.04%" y2="0%" id="illustration-500_svg__e">
          <stop stopColor="#F5F5F5" offset="0%" />
          <stop stopColor="#E4E8EE" offset="100%" />
        </linearGradient>
        <linearGradient x1="18.04%" y1="87.79%" x2="18.04%" y2="0%" id="illustration-500_svg__f">
          <stop stopColor="#F5F5F5" offset="0%" />
          <stop stopColor="#E4E8EE" offset="100%" />
        </linearGradient>
        <ellipse id="illustration-500_svg__c" cx={105.746} cy={105.09} rx={105.746} ry={105.09} />
        <path id="illustration-500_svg__a" d="M0 0h330v250H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="illustration-500_svg__b" fill="#fff">
          <use xlinkHref="#illustration-500_svg__a" />
        </mask>
        <g mask="url(#illustration-500_svg__b)">
          <g transform="translate(59 3)">
            <mask id="illustration-500_svg__d" fill="#fff">
              <use xlinkHref="#illustration-500_svg__c" />
            </mask>
            <use fill="#F5F5F5" xlinkHref="#illustration-500_svg__c" />
            <g mask="url(#illustration-500_svg__d)">
              <path fill="#E8E9EA" d="M101 155h70v5h-70zM101 185h70v5h-70z" />
              <g transform="translate(97 130)">
                <path
                  d="M74 60a4 4 0 014 4v18a4 4 0 01-4 4H4a4 4 0 01-4-4V64a4 4 0 014-4h70zm0-30a4 4 0 014 4v18a4 4 0 01-4 4H4a4 4 0 01-4-4V34a4 4 0 014-4h70zm0-30a4 4 0 014 4v18a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4h70z"
                  fill="url(#illustration-500_svg__e)"
                />
                <circle fill="#FFF" cx={10} cy={13} r={3} />
                <circle fill="#FFF" cx={18} cy={13} r={3} />
                <circle fill="#FFF" cx={26} cy={13} r={3} />
                <rect fill="#FFF" x={49} y={10} width={25} height={6} rx={1} />
              </g>
              <g transform="translate(97 160)" fill="#FFF">
                <circle cx={10} cy={13} r={3} />
                <circle cx={18} cy={13} r={3} />
                <circle cx={26} cy={13} r={3} />
                <rect x={49} y={10} width={25} height={6} rx={1} />
              </g>
              <g transform="translate(97 190)" fill="#FFF">
                <circle cx={10} cy={13} r={3} />
                <circle cx={18} cy={13} r={3} />
                <circle cx={26} cy={13} r={3} />
                <rect x={49} y={10} width={25} height={6} rx={1} />
              </g>
            </g>
            <g mask="url(#illustration-500_svg__d)">
              <path
                fill="#E8E9EA"
                d="M25.487 162.795h61.026v4.359H25.487zM25.487 188.949h61.026v4.359H25.487z"
              />
              <g transform="translate(22 141)">
                <path
                  d="M64 52.308a4 4 0 014 4v14.666a4 4 0 01-4 4H4a4 4 0 01-4-4V56.308a4 4 0 014-4h60zm0-26.154a4 4 0 014 4V44.82a4 4 0 01-4 4H4a4 4 0 01-4-4V30.154a4 4 0 014-4h60zM64 0a4 4 0 014 4v14.667a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4h60z"
                  fill="url(#illustration-500_svg__f)"
                />
                <circle fill="#FFF" cx={8.718} cy={11.333} r={2.615} />
                <circle fill="#FFF" cx={15.692} cy={11.333} r={2.615} />
                <circle fill="#FFF" cx={22.667} cy={11.333} r={2.615} />
                <rect fill="#FFF" x={42.718} y={8.718} width={21.795} height={5.231} rx={1} />
              </g>
              <g transform="translate(22 167.154)" fill="#FFF">
                <circle cx={8.718} cy={11.333} r={2.615} />
                <circle cx={15.692} cy={11.333} r={2.615} />
                <circle cx={22.667} cy={11.333} r={2.615} />
                <rect x={42.718} y={8.718} width={21.795} height={5.231} rx={1} />
              </g>
              <g transform="translate(22 193.308)" fill="#FFF">
                <circle cx={8.718} cy={11.333} r={2.615} />
                <circle cx={15.692} cy={11.333} r={2.615} />
                <circle cx={22.667} cy={11.333} r={2.615} />
                <rect x={42.718} y={8.718} width={21.795} height={5.231} rx={1} />
              </g>
            </g>
            <g mask="url(#illustration-500_svg__d)" fill="#FFF">
              <path d="M71 108h8v18h-8zM84 108h8v18h-8z" />
            </g>
            <g mask="url(#illustration-500_svg__d)">
              <g transform="translate(36.91 44.482)">
                <rect
                  stroke="#18263C"
                  strokeWidth={0.6}
                  fill="#FFF"
                  x={0.3}
                  y={0.3}
                  width={137.33}
                  height={109.371}
                  rx={2}
                />
                <path
                  d="M135.93.3c.47 0 .894.19 1.202.498.308.308.498.733.498 1.202h0v8.836H.3V2c0-.47.19-.894.498-1.202A1.695 1.695 0 012 .3h0z"
                  stroke="#18263C"
                  strokeWidth={0.6}
                  fill="#FFF"
                />
                <ellipse fill="#D96156" cx={8.445} cy={5.568} rx={2.815} ry={2.784} />
                <ellipse fill="#F7B035" cx={16.889} cy={5.568} rx={2.815} ry={2.784} />
                <ellipse fill="#57BB52" cx={25.334} cy={5.568} rx={2.815} ry={2.784} />
              </g>
            </g>
          </g>
          <path
            stroke="#18263C"
            strokeWidth={0.6}
            fill="#FFF"
            d="M259.455 235.164h7.266v4.008h-7.266zM240.825 235.164h7.266v4.008h-7.266z"
          />
          <path
            d="M267.237 237.637c.54 0 1.03.22 1.384.573a1.95 1.95 0 01.497 1.924 3.673 3.673 0 01-3.535 2.664h0-9.167a3.34 3.34 0 01-2.102-.744 3.34 3.34 0 01-1.168-1.9 2.074 2.074 0 01.287-1.566c.289-.447.748-.784 1.31-.905h0zM248.438 237.637c.54 0 1.03.22 1.384.573a1.95 1.95 0 01.497 1.924 3.673 3.673 0 01-3.535 2.664h0-9.167a3.34 3.34 0 01-2.103-.744 3.34 3.34 0 01-1.168-1.9 2.074 2.074 0 01.288-1.566c.289-.447.748-.784 1.31-.905h0z"
            stroke="#18263C"
            strokeWidth={0.6}
            fill="#D6DAE1"
          />
          <path
            d="M235.715 130.561c-5.136 7.874-4.318 10.52-4.318 42.063 0 21.028 2.628 42.04 7.883 63.039h9.243c4.769-44.752 7.543-71.274 8.324-79.565.78-8.29 1.281-16.555 1.502-24.793-11.665-5.745-19.21-5.993-22.634-.744z"
            stroke="#1A1A1A"
            strokeWidth={0.6}
            fill="#FFF"
          />
          <path
            d="M280.537 141c.594 11.731.306 24.977-.866 39.737-1.17 14.76-5.299 33.068-12.383 54.926h-8.226c-4.902-54.621-5.98-87.417-3.233-98.388 2.747-10.971 10.983-9.73 24.708 3.725zM268.116 110.78c-1.707-4.58-7.769-9.606-18.184-15.076-15.623-8.205-5.831-33.62-1.428-33.62 2.922 0 2.52.152 3.775-.692.287-.193 2.229-2.101 2.316-2.44.026-.1 1.432-1.423 1.493-2.338.11-1.663-2.493-3.133-3.945-3.543-2.072-.586-4.085.753-6.038 4.016-3.613 2.34-5.788 3.775-6.525 4.305-11.167 8.02-17.449 34.031-.227 43.656 18.188 10.164 21.238 7.05 9.15-9.344"
            stroke="#18263C"
            strokeWidth={0.6}
            fill="#FFF"
          />
          <path
            stroke="#18263C"
            strokeWidth={0.4}
            fill="#FFF"
            d="M262.103 73.947l2.136 10.303-12.443 2.97 2.765-10.733z"
          />
          <path
            d="M262.58 74.597c-7.331 2.938-12.285 4.025-14.86 3.26-3.865-1.145-5.753-12.692-4.809-14.851.944-2.16 13.906-7.276 16.178-.898 1.514 4.253 2.678 8.415 3.491 12.489z"
            stroke="#18263C"
            strokeWidth={0.4}
            fill="#FFF"
          />
          <path
            d="M253.24 65.706c-1.667-1.08-2.457-.235-2.368 2.536h-1.72c-.133-3.355-2.242-5.032-6.326-5.032-6.127 0-2.945-11.754.388-12.364 1.376-.252 1.101-.113.824.281-.395.56-.817.84 1 .84 3.094 0 11.693.047 17.7 2.785 4.004 1.826 4.204 7.782.598 17.87l-6.294 1.325-3.801-3.36c1.667-2.174 1.667-3.802 0-4.881z"
            fill="#18263C"
          />
          <path
            d="M249.031 82.858c.768-1.285-.065-1.713-2.5-1.285-3.652.642-15.473 12.485-15.473 15.538 0 3.053 6.546 11.677 7.835 11.677.86 0 4.24-8.644 10.138-25.93z"
            stroke="#18263C"
            strokeWidth={0.4}
            fill="#D6DAE1"
          />
          <path
            d="M266.684 83.114c-6.284-2.492-10.842 3.044-16.402-1.425-5.56-4.47-28.255 54.968-23.64 59.03 4.616 4.063 50.498 8.518 56.43 3.58 3.955-3.29 1.825-21.71-6.39-55.26-4.385-3.106-7.718-5.081-9.998-5.925z"
            stroke="#18263C"
            strokeWidth={0.4}
            fill="#D6DAE1"
          />
          <g stroke="#18263C">
            <path
              d="M275.039 93.073c-5.103 1.385-8.598 8.282-10.486 20.692-.594 3.902-.009 7.447-4.504 11.837-2.997 2.927-16.532 6.214-40.605 9.861-5.403 1.193-7.226 2.337-5.467 3.431 2.39 1.488 0 3.075 5.467 3.075 4.625 0 4.64-2.231 6.046-2.068 41.885 4.88 57.477-5.397 59.339-27.509 1.241-14.74-2.022-21.18-9.79-19.319z"
              strokeWidth={0.6}
              fill="#FFF"
            />
            <path
              d="M285.116 113.765h-20.563c-4.389-16.591-1.454-24.887 8.803-24.887 10.258 0 14.178 8.296 11.76 24.887z"
              strokeWidth={0.4}
              fill="#D6DAE1"
            />
          </g>
        </g>
        <circle stroke="#18263C" strokeWidth={0.6} fill="#FFF" cx={79} cy={33} r={19.7} />
        <g>
          <path
            d="M146.375 148.836c20.917-1.977 23.999-7.289 27.214-8.137C189.959 136.381 202 121.81 202 104.5c0-20.71-17.237-37.5-38.5-37.5S125 83.79 125 104.5c0 17.637 12.5 32.43 29.34 36.432 1.37.326-.575 2.753-2.27 4.238-1.693 1.485-7.38 3.666-5.695 3.666z"
            fill="#126BFB"
          />
          <path
            d="M173.759 90.048c.55.592.999 1.265 1.332 2.018.4.897.6 1.858.6 2.883v17.17h.016c0 1.025-.2 1.986-.6 2.883-.4.897-.949 1.682-1.631 2.339a7.731 7.731 0 01-2.432 1.57 7.788 7.788 0 01-2.997.576h-6.795a7.788 7.788 0 01-2.998-.576 7.731 7.731 0 01-2.431-1.57 7.799 7.799 0 01-.833-.961l8.26-11.58v4.052c0 .384.134.704.4.96.267.257.6.385 1 .385.399 0 .732-.128.998-.384.267-.257.4-.577.4-.961v-7.977l7.71-10.827zm25 0c.55.592.999 1.265 1.332 2.018.4.897.6 1.858.6 2.883v17.17h.016c0 1.025-.2 1.986-.6 2.883-.4.897-.949 1.682-1.631 2.339a7.731 7.731 0 01-2.432 1.57 7.788 7.788 0 01-2.997.576h-6.795a7.788 7.788 0 01-2.998-.576 7.731 7.731 0 01-2.431-1.57 7.799 7.799 0 01-.833-.961l8.26-11.58v4.052c0 .384.134.704.4.96.267.257.6.385 1 .385.399 0 .732-.128.998-.384.267-.257.4-.577.4-.961v-7.977l7.71-10.827zm-49.667 9.75a4.802 4.802 0 011.94 3.643l.005.22v10.767a4.809 4.809 0 01-4.589 4.804l-.22.005h-16.157a2.09 2.09 0 01-2.09-2.091v-5.227a2.09 2.09 0 012.09-2.09h11.557v-1.236l7.464-8.795zm18.01-11.931c1.053 0 2.041.192 2.963.576a7.882 7.882 0 012.371 1.536l-7.294 10.35v-1.84c0-.383-.132-.703-.395-.96a1.361 1.361 0 00-.988-.383c-.395 0-.725.128-.988.384a1.283 1.283 0 00-.395.96v5.76l-8.447 11.966a6.82 6.82 0 01-.527-.96 7.056 7.056 0 01-.592-2.88v-17.15c0-1.024.197-1.984.592-2.88a7.394 7.394 0 011.614-2.335 7.636 7.636 0 012.404-1.568 7.632 7.632 0 012.964-.576h6.717zm25 0c1.053 0 2.041.192 2.963.576a7.882 7.882 0 012.371 1.536l-7.294 10.35v-1.84c0-.383-.132-.703-.395-.96a1.361 1.361 0 00-.988-.383c-.395 0-.725.128-.988.384a1.283 1.283 0 00-.395.96v5.76l-8.447 11.966a6.82 6.82 0 01-.527-.96 7.056 7.056 0 01-.592-2.88v-17.15c0-1.024.197-1.984.592-2.88a7.394 7.394 0 011.614-2.335 7.636 7.636 0 012.404-1.568 7.632 7.632 0 012.964-.576h6.717zm-43.219.01a2.09 2.09 0 012.091 2.09v5.227a2.09 2.09 0 01-1.935 2.085l-.156.005h-11.476v1.568h8.821c.693 0 1.352.147 1.947.41l-7.636 8.997-7.731.002a4.809 4.809 0 01-4.804-4.589l-.005-.22V92.685a4.809 4.809 0 014.589-4.804l.22-.005h16.075z"
            fill="#FFF"
            fillRule="nonzero"
          />
        </g>
        <g fill="#D96156" fillRule="nonzero">
          <path d="M77.945 35.44a1.074 1.074 0 002.112 0l.704-9.68A1.764 1.764 0 0079 24a1.81 1.81 0 00-1.76 1.936l.704 9.504zM79 38.08a1.76 1.76 0 101.76 1.76A1.663 1.663 0 0079 38.08z" />
        </g>
      </g>
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgIllustration500)
const MemoForwardRef = React.memo(ForwardRef)
export default MemoForwardRef
